import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { checklistsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import LazyAction from '../../../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../../../components/helpers/StatePresenter'
import { useTranslation } from 'react-i18next'

const Context = React.createContext()
const { Provider } = Context
export const useQuestionTypesState = () => React.useContext(Context) || {}
export const useQuestionTypes = () => useQuestionTypesState()?.questionTypes || []

const QUERY = gql`
  query QuestionTypes {
    questionTypes(sort: { field: NAME, type: ASC }, limit: 9000) {
      id
      name
      deleted
    }
  }
`

const QuestionTypesLoader = ({ children, uncontrolledChildren }) => {
  const { t } = useTranslation()
  const { data, ...state } = useQuery(QUERY, {
    client: checklistsClient,
    fetchPolicy: 'cache-first'
  })

  const sortedData = React.useMemo(() => {
    return {
      questionTypes:
        data?.questionTypes
          ?.slice()
          .sort((a, b) => t('fieldTypes.' + a.name).localeCompare(t('fieldTypes.' + b.name))) || []
    }
  }, [data?.questionTypes, t])

  return (
    <Provider value={sortedData}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default QuestionTypesLoader
